import React, { useState } from 'react';
import { Formik } from 'formik';
import Base, { ContentContainer } from '../../components/Base';
import { ButtonActionBack, ButtonSelectCategory, DivActionBack, Form, FormControl, H1, H2, HeaderTitle, ImgIconBack, LegendTitle, Title, } from '../../assets/styles/GlobalStyles';
import { BgSelectAppWebForm, Logo, LogoContainer } from "../../components/Base/styled";
import LogoAppWebSelectFarm from "../../assets/images/fundo-rosa-cima.png";
import LogoBoxSelectCategory from '../../assets/images/logo-box-select-category.svg';
import ImageHealthUdder from '../../assets/images/image-health-udder.svg';
import ImageHealthUdderWhiteFocus from '../../assets/images/iamge-health-udder-white-focus.svg';
import ImageHealthHeifer from '../../assets/images/image-health-heifer.svg';
import ImageHealthHeiferWhiteFocus from '../../assets/images/image-health-heifer-white-focus.svg';
import IconBack from '../../assets/icon/icon-back.svg';
import { translate } from '../../i18n/index';

const SelectCategory = ({ history }) => {

    const [focusUdder, setFocusUdder] = useState(false);
    const [focusHeifer, setFocusHeifer] = useState(false);
    const [categorySelected, setCategorySelected] = useState({});
    const categoryHealthUdder = 'health-udder';
    const categoryHealthHeifer = 'health-heifer';

    function handleClickSelectCategory(value) {
        setCategorySelected(value);
    }


    return (
        <>
            <DivActionBack>
                <ButtonActionBack onClick={() => history.goBack()} type="button">
                    <ImgIconBack src={IconBack} className="icon-back" alt="Button Back" />{translate('buttonActionBack')}
                </ButtonActionBack>
            </DivActionBack>
            <div>
                <HeaderTitle>
                    <LegendTitle>
                        {translate('almostThere')}
                    </LegendTitle>
                    <H2>
                        {translate('nowSelectFarmCategory')}
                    </H2>
                </HeaderTitle>
            </div>
            <div>
                <LogoContainer
                    style={{ alignSelf: 'center' }}
                    rel="noopener noreferrer"
                    target="_self">
                    <BgSelectAppWebForm src={LogoAppWebSelectFarm} alt="Logo OnFarm" title="OnFarm" />
                </LogoContainer>
            </div>
            <Base width={430} isAppWeb={true}>
                <ContentContainer>
                    <Formik
                        enableReinitialize
                        initialValues={{
                            category: '',
                        }}
                        onSubmit={async (values, actions) => {
                            if (categorySelected) {
                                console.log('categorySelected: ', categorySelected)

                                if (categorySelected === categoryHealthUdder) {
                                    window.location = `${process.env.REACT_APP_WEB_URL}`;
                                } else if (categorySelected === categoryHealthHeifer) {
                                    window.location = `${process.env.REACT_APP_WEB_URL}/home-bezerra`;
                                }
                            }
                        }}>
                        {({ isSubmitting }) => (
                            <Form>
                                <Title>
                                    <H1>
                                        <LogoContainer
                                            href='#'
                                            style={{ alignSelf: 'center' }}
                                            rel="noopener noreferrer"
                                            target="_self">
                                            <Logo height="100px" src={LogoBoxSelectCategory} alt="Logo do site" title="OnFarm" />
                                        </LogoContainer>
                                    </H1>
                                </Title>
                                <div>
                                    <FormControl>
                                        <ButtonSelectCategory onClick={() => handleClickSelectCategory(categoryHealthUdder)} key="health-udder" onBlur={() => setFocusUdder(false)} onFocus={() => setFocusUdder(true)} type="submit">
                                            <img src={focusUdder ? ImageHealthUdderWhiteFocus : ImageHealthUdder} alt="Saúde da bezerra" />
                                        </ButtonSelectCategory>
                                    </FormControl>
                                    <FormControl>
                                        <ButtonSelectCategory onClick={() => handleClickSelectCategory(categoryHealthHeifer)} key="health-heifer" onBlur={() => setFocusHeifer(false)} onFocus={() => setFocusHeifer(true)} type="submit">
                                            <img src={focusHeifer ? ImageHealthHeiferWhiteFocus : ImageHealthHeifer} alt="Saúde da bezerra" />
                                        </ButtonSelectCategory>
                                    </FormControl>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </ContentContainer>
            </Base>
        </>
    );
};

export default SelectCategory;
